































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import formatNumber from '@/shared/filters/format-number';

@Component
export default class ListTransition extends Vue {
    @Prop({ default: () => [] })
    private listItem!: any[];

    public getOrderDetailRoute(item: any) {
        if (!item || !item.OrderID) {
            return {};
        }
        if (item.PackageType === 0) {
            return { name: 'order-detail', params: { orderId: item.OrderID.toString() } };
        }
        return { name: 'deposit-detail', params: { id: item.OrderID.toString() } };
    }

    public getChargeableWeightUnit(item: any): string {
        return item && item.FeeShipType === 1 ? 'm³' : 'kg';
    }

    private getChargeableWeight(item: any): number {
        const weight = item.Weight || 0;
        const weightByVolume = item.WeightByVolume || 0;
        const feeShipType = item ? item.FeeShipType : 0;
        return feeShipType === 0 ? weight : feeShipType === 1 ? (item.Volume || 0) : weightByVolume;
    }

    private getShippingFee(item: any): number {
        const chargeableWeight = this.getChargeableWeight(item);
        const feeWeight = item.FeeWeight || 0;
        return chargeableWeight * feeWeight;
    }

    get totalShippingFee(): number {
        if (!Array.isArray(this.listItem)) {
            return 0;
        }
        return this.listItem.reduce((sum: number, item: any) => sum + this.getShippingFee(item), 0);
    }

    private formatDimension(item: any): string {
        if (item && (item.Length > 0 || item.Width > 0 || item.Height > 0)) {
            return `${formatNumber(item.Length || 0, '0,0')} x ${formatNumber(item.Width || 0, '0,0')} x ${formatNumber(item.Height || 0, '0,0')}`;
        }
        return '';
    }

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '0';
        }
        return formatNumber(value, format);
    }

    private copyCode(code: string) {
        if (!code) {
            return;
        }
        navigator.clipboard.writeText(code);
        Vue.notify({
            group: 'foo',
            type: 'success',
            title: 'Thông báo',
            text: `Đã sao chép mã ${code}`
        });
    }
}
